import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import { getToken } from "../api/auth";
import { FaBars } from "react-icons/fa";
import "./ProtectedRoute.css";

const ProtectedRoute = () => {
  const token = getToken();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false); // Close sidebar on desktop
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="protected-layout">
      {isMobile && (
        <button
          className="sidebar-toggle glass-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle menu"
        >
          <FaBars size={20} />
        </button>
      )}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isMobile={isMobile}
      />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedRoute;
